import axios from "axios";

export const API = axios.create({
  baseURL: "https://oneclick-api.skyapi.store",
  //baseURL: "http://localhost:1278/",
});
